import { render, staticRenderFns } from "./SatinalmaFaturalari.vue?vue&type=template&id=1408092a&"
import script from "./SatinalmaFaturalari.vue?vue&type=script&lang=js&"
export * from "./SatinalmaFaturalari.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports